import React from 'react';
import PropTypes from 'prop-types';
import {withCookies, Cookies} from 'react-cookie';
import Favicon from 'react-favicon';

import {Header, Footer, CookiesBot} from '../components';
import texts from '../texts';

import 'react-select/dist/react-select.css';

import faviconImg from '../assets/img/favicon.ico';
import pfImage from '../assets/img/15D66911-5971-413F-A6A4-0A46FDC15AC6.jpeg';

// todo dodělat Hledání v poradně a v headeru

class App extends React.Component {
  constructor() {
    super();
    this.state = {
      fbBannerActive: false,
    }
  }

  closeFbBanner = () => {
    //this.props.cookies.set('pfBanner', true, {path: '/'});
    this.props.cookies.set('fbBanner', true, {path: '/'});
    this.setState({
      fbBannerActive: false
    })
  };

  componentDidMount() {
    //if (!this.props.cookies.get("pfBanner")) {
    if (!this.props.cookies.get("fbBanner")) {
      setTimeout(() => {
        this.setState({
          fbBannerActive: true
        });
      }, 12000);
    }
  }

  renderFbBanner = () => {
    if (this.state.fbBannerActive === true) {
      return (
        /*
        <div className="fbBanner pfBanner">
          <div className="fbBanner_content">
            <button className="fbBanner_close" onClick={this.closeFbBanner}>
              <i className="llc-error"/>
            </button>

            Celý tým Kliniky LLC spolu s Prim. MUDr. Igorem Janíkem přeje klientům od srdce klidné
            svátky prožité ve zdraví a hlavně ve společnosti své rodiny. V novém roce, ať každý má pořádný kus štěstí.
            Budeme se těšit na každého z Vás v roce 2020.

            <img src={pfImage} alt=""/>
          </div>
        </div>
        */
        <div className="fbBanner">
          <div className="fbBanner_content">
            <button className="fbBanner_close" onClick={this.closeFbBanner}><i className="llc-error"/>
            </button>
            <a
              href="https://www.facebook.com/KLINIKA-LLC-PLASTICK%C3%81-CHIRURGIE-A-LASEROV%C3%89-L%C3%89%C4%8CEBN%C3%89-CENTRUM-114194068604606/"
              target="_blank" onClick={this.closeFbBanner}>
              <i className="llc-facebook-logo-button"/>
              Prosím dejte To se mi líbí <br/> na náš facebook.
            </a>
          </div>
        </div>
      )
    }
  };

  render() {
    return (
      <div>
        <Favicon url={faviconImg}/>
        {this.renderFbBanner()}
        <Header
          page={this.props.location.pathname}
        />
        {React.cloneElement(this.props.children, {
          texts
        })}
        <Footer
          langs={
            {
              footer: texts.langs.footer, main: texts.langs.main
            }
          }
          branches={texts.gen.branches}
        />
        <CookiesBot/>
      </div>
    );
  }
}

App.propTypes = {
  children: PropTypes.element
};

export default withCookies(App);



// WEBPACK FOOTER //
// ./src/containers/App.js